export const blankDemand = () => ({
  sourceDocumentNo: '', sourceLineNo: '', customerName: '', model: '', drawingNo: '', itemName: '',
  demandQuantity: '', plannedDeliveryDate: '', deliveryDateText: '', productionBatchNo: '', demandRemark: '',
  sourceKind: 'Image', sourceFileName: '', sourceSheet: '', sourceRow: null, sourceCompanyCode: '', sourceConfirmed: false,
});
const compact = (value) => String(value || '').normalize('NFKC').replace(/\s/g, '');
export function parseDemandDate(text) {
  const match = String(text || '').trim().match(/^(\d{2,4})[./\-年](\d{1,2})[./\-月](\d{1,2})日?$/);
  if (!match) return '';
  let year = Number(match[1]); if (match[1].length <= 3) year += 1911;
  const month = Number(match[2]); const day = Number(match[3]);
  const date = new Date(Date.UTC(year, month - 1, day));
  if (date.getUTCFullYear() !== year || date.getUTCMonth() + 1 !== month || date.getUTCDate() !== day) return '';
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

// Keep word coordinates to reconstruct table columns; flattened OCR text loses cell boundaries.
export function parseOcrDemand(data, filename, companies = []) {
  const words = String(data.tsv || '').split(/\r?\n/).slice(1).map((line) => {
    const c = line.split('\t');
    return { level: Number(c[0]), x: Number(c[6]), y: Number(c[7]), width: Number(c[8]), height: Number(c[9]), text: c.slice(11).join('\t').normalize('NFKC').trim() };
  }).filter((x) => x.level === 5 && x.text && Number.isFinite(x.x) && Number.isFinite(x.y));
  const heights = words.map((x) => x.height).filter((x) => x > 0).sort((a, b) => a - b);
  const lineTolerance = Math.max(6, Math.min(30, (heights[Math.floor(heights.length / 2)] || 20) * 0.65));
  const lines = [];
  words.sort((a, b) => a.y + a.height / 2 - b.y - b.height / 2 || a.x - b.x).forEach((word) => {
    const center = word.y + word.height / 2;
    let line = lines.find((x) => Math.abs(x.y - center) <= lineTolerance);
    if (!line) { line = { y: center, height: word.height, words: [] }; lines.push(line); }
    line.words.push(word);
  });
  const labels = ['項次', '機種', '品名', '圖號', '訂單數量', '交貨日', '生產批號', '備註'];
  const headerAliases = [['項次', '項灰', '項炊'], ['機種'], ['品名'], ['圖號'], ['訂單數量', '訂單數'], ['預定交貨日', '交貨日', '交貨'], ['生產批號'], ['備註', '進價']];
  let context = blankDemand(); context.sourceFileName = filename;
  let centers = null;
  const items = [];
  lines.sort((a, b) => a.y - b.y).forEach((line) => {
    line.words.sort((a, b) => a.x - b.x);
    const text = line.words.map((w) => w.text).join(''); const normalized = compact(text);
    const company = companies.find((x) => normalized === compact(x.name));
    if (company) { context = { ...blankDemand(), sourceFileName: filename, sourceCompanyCode: company.code }; centers = null; }
    const doc = normalized.match(/單號[:：]?([A-Za-z0-9-]+)/); if (doc) { context.sourceDocumentNo = doc[1]; centers = null; }
    const customer = text.match(/(?:客|宮)\s*戶\s*名\s*稱[:：]?(.+?)(?:連絡人|聯絡人|電話|傳真|單號|$)/);
    if (customer) context.customerName = customer[1].trim();
    if (normalized.includes('圖號') && normalized.includes('訂單數')) {
      const chars = [];
      line.words.forEach((word) => [...word.text].forEach((char, i) => {
        if (!/\s/.test(char)) chars.push({ char, x: word.x + word.width * (i + 0.5) / word.text.length });
      }));
      const joined = chars.map((x) => x.char).join('');
      const positions = headerAliases.map((aliases) => {
        const label = aliases.find((name) => joined.includes(name));
        if (!label) return null;
        const i = joined.indexOf(label); return (chars[i].x + chars[i + label.length - 1].x) / 2;
      });
      centers = positions.every((x) => x !== null) && positions.every((x, i) => i === 0 || x > positions[i - 1]) ? positions : null;
      return;
    }
    if (normalized.includes('以下空白') || normalized.includes('會簽')) { centers = null; return; }
    if (!centers) return;
    const cells = labels.map(() => []);
    line.words.forEach((word) => {
      const x = word.x + word.width / 2;
      let index = 0; while (index < 7 && x > (centers[index] + centers[index + 1]) / 2) index += 1;
      cells[index].push(word.text);
    });
    const values = cells.map((x) => x.join(''));
    if (!/^\d+$/.test(values[0]) || !values[3]) return;
    const quantity = values[4].replace(/,/g, '');
    items.push({ fields: { ...context, sourceLineNo: values[0], model: values[1], itemName: values[2], drawingNo: values[3],
      demandQuantity: /^\d+(\.\d{1,4})?$/.test(quantity) ? quantity : '', deliveryDateText: values[5],
      plannedDeliveryDate: parseDemandDate(values[5]), productionBatchNo: values[6], demandRemark: values[7] },
    sourceCompanyName: company?.name || '', warnings: ['照片辨識結果需逐欄核對，圖號與數量不可直接視為正確。'], errors: [] });
  });
  // A difficult photo remains usable: let the operator correct the draft beside the image/text.
  if (!items.length) {
    const text = compact(data.text || '');
    context.sourceDocumentNo ||= text.match(/單號[:：]?([A-Za-z0-9-]+)/)?.[1] || '';
    context.sourceCompanyCode ||= companies.find((x) => text.startsWith(compact(x.name)))?.code || '';
    items.push({ fields: context, sourceCompanyName: '', warnings: ['無法可靠分離表格欄位，請對照圖片與辨識原文補齊明細。'], errors: [] });
  }
  return items;
}
